//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_contact_tsl_kontakttyp {
	FackligAnstlldombudsman = 1,
	FackligLokalfackligrepresentant = 3,
	Deltagare = 4,
	FretagHRchef = 5,
	FretagHRspecialist = 6,
	Fretag = 7,
	FretagVD = 9,
	Facklig = 10,
	Leverantr = 20,
	Utbildningsleverantr = 30,
	Konfiguration = 100,
};
